import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Belonging } from '@spike/belonging-model';
import clsx from 'clsx';
import ClickAwayListener from 'components/CreateBooking/UI/ClickAwayListener';
import React from 'react';
import styles from './BelongingPicker.module.scss';

interface BelongingPickerProps {
    belongings: Array<Belonging>;
    excludeIds?: Array<number>;
    loading: boolean;
    className?: string;
    onSelect: (belonging: Belonging) => void;
    onAddNew: () => void;
    onClose: () => void;
}

const BelongingPicker: React.FC<BelongingPickerProps> = ({
    belongings,
    excludeIds = [],
    loading,
    className,
    onSelect,
    onAddNew,
    onClose
}) => {
    const availableBelongings = belongings.filter(b => !excludeIds.includes(b.id));

    return (
        <ClickAwayListener onClickAway={onClose}>
            <div className={clsx(styles.panel, className)}>
                <div className={styles.list}>
                    {loading && <p className={styles.status}>Loading...</p>}
                    {!loading && availableBelongings.length === 0 && <p className={styles.status}>No belongings yet</p>}
                    {!loading &&
                        availableBelongings.map(belonging => (
                            <button
                                key={belonging.id}
                                className={styles.item}
                                onClick={() => onSelect(belonging)}
                            >
                                {belonging.name}
                            </button>
                        ))}
                </div>
                <div className={styles.footer}>
                    <button
                        className={styles.addNew}
                        onClick={onAddNew}
                    >
                        <FontAwesomeIcon
                            icon={faPlus}
                            className={styles.addNewIcon}
                        />
                        Add New
                    </button>
                </div>
            </div>
        </ClickAwayListener>
    );
};

export default BelongingPicker;
